<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadrumbItems"></app-breadcrumb>

  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="self-stretch flex-col justify-start items-center gap-6 flex mb-10">
        <div class="self-stretch flex-col justify-start items-start gap-6 flex">
          <div class="self-stretch flex-col justify-start items-start gap-5 flex">
            <div class="self-stretch justify-start items-start gap-4 inline-flex">
              <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                <div class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px]">
                  Gestion des certificats
                </div>
                <div class="self-stretch text-slate-600 text-base font-interRegular leading-normal">
                  Vous trouverez ici la liste de certificats et de webinaires
                  disponibles.
                </div>
              </div>
              <!-- Bouton importer des intervenants (annuaire seul, sans webinaire) -->
              <button *ngIf="isAdmin && !isBeninGestionnaire && filterType === 'webinaire'" type="button" (click)="openImportIntervenantsModal()"
                title="Ajouter des animateurs et modérateurs à l'annuaire depuis un fichier Excel"
                class="transition hover:bg-gray-200 px-4 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
                <svg width="20" height="20" style="width:20px;height:20px;flex:0 0 auto" fill="none" viewBox="0 0 24 24"
                  stroke="#475467" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 16V4m0 0-4 4m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                </svg>
                <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                  Importer des intervenants
                </div>
              </button>
              <!-- Dropdown ajouter un nouveau certificat -->
              <div class="justify-start items-center gap-3 flex relative" *ngIf="!isBeninGestionnaire">
                <button (click)="toggleDropdown()"
                  class="transition hover:bg-gray-200 px-4 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
                  <div class="relative">
                    <img src="assets/icons/plus.png" alt="plus" style="width: 22px; height: 22px" />
                  </div>
                  <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                    Ajouter un certificat
                  </div>
                  <div class="ml-1">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 6L8 10L12 6" stroke="#475467" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </button>
                <!-- Menu dropdown -->
                <div *ngIf="isDropdownOpen"
                  class="absolute top-full right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 w-64 z-10 py-1">
                  <a [routerLink]="['../newcertificate']"
                    class="flex items-center px-4 py-2.5 hover:bg-gray-100 cursor-pointer text-slate-700">
                    <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                      Certificat de parcours
                    </div>
                  </a>
                  <a [routerLink]="['/dashboard/appels/hors-sigui-certificate']"
                    class="flex items-center px-4 py-2.5 hover:bg-gray-100 cursor-pointer text-slate-700">
                    <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                      Certificat hors parcours
                    </div>
                  </a>
                  <a [routerLink]="['../new-mentorat-certificat']"
                    class="flex items-center px-4 py-2.5 hover:bg-gray-100 cursor-pointer text-slate-700">
                    <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                      Certificat mentorat
                    </div>
                  </a>
                  <ng-container *ngIf="isAdmin">
                    <a [routerLink]="['/dashboard/appels/webinaire/create']"
                      class="flex items-center px-4 py-2.5 hover:bg-gray-100 cursor-pointer text-slate-700">
                      <div class="text-slate-700 text-md font-semibold font-['Inter'] leading-tight">
                        Webinaire
                      </div>
                    </a>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- filtres pour les certificats -->
      <div class="mb-6 flex justify-start items-center gap-4 pb-4" *ngIf="!isBeninGestionnaire">
        <div class="font-medium text-slate-700">Afficher :</div>
        <div class="flex space-x-2">
          <button class="px-4 py-2 rounded-lg transition-all" [ngClass]="
              filterType === 'all'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
            " (click)="filterCertificats('all')">
            Tous les certificats
          </button>
          <button class="px-4 py-2 rounded-lg transition-all" [ngClass]="
              filterType === 'parcours'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
            " (click)="filterCertificats('parcours')">
            Certificats de parcours
          </button>
          <button class="px-4 py-2 rounded-lg transition-all" [ngClass]="
              filterType === 'horsParcours'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
            " (click)="filterCertificats('horsParcours')">
            Certificats hors parcours
          </button>
          <button class="px-4 py-2 rounded-lg transition-all" [ngClass]="
              filterType === 'mentorat'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
            " (click)="filterCertificats('mentorat')">
            Certificats mentorat
          </button>
          <button class="px-4 py-2 rounded-lg transition-all" [ngClass]="
              filterType === 'webinaire'
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-slate-700 hover:bg-gray-200'
            " (click)="filterCertificats('webinaire')" *ngIf="isAdmin">
            Webinaires
          </button>
        </div>
      </div>

      <!-- Barre de recherche (uniquement pour les webinaires) -->
      <div class="mb-6 flex items-center gap-2 w-full sm:w-96" *ngIf="filterType === 'webinaire'">
        <div
          class="flex items-center w-full rounded-lg border border-gray-300 bg-white px-3 py-2 focus-within:ring-2 focus-within:ring-blue-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#98A2B3"
            width="18" height="18" class="shrink-0">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
          <input type="text" [ngModel]="webinaireSearchTerm" (ngModelChange)="onWebinaireSearchChange($event)"
            placeholder="Rechercher un webinaire "
            class="w-full ml-2 border-0 outline-none focus:outline-none focus:ring-0 text-slate-700" />
          <button *ngIf="webinaireSearchTerm" type="button" (click)="clearWebinaireSearch()"
            title="Effacer la recherche" class="shrink-0 ml-2 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#98A2B3"
              width="18" height="18">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Liste des certificats -->
      <div class="self-stretch h-full flex-col justify-start items-center gap-4 flex pt-4">
        <div class="self-stretch w-full h-full flex-col justify-start items-start gap-8 flex">
          <div class="self-stretch w-full h-full flex flex-col justify-start items-start gap-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-4 w-full">
              <div class="bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700"
                *ngFor="let certificat of certificatsToDisplay">
                <figure class="relative">
                  <a>
                    <img class="rounded-t-lg w-full" src="assets/img/image-3.png" alt="" />
                    <figcaption class="absolute px-4 text-lg text-white top-2 rounded font-semibold">
                      <p [style.backgroundColor]="
                          certificat.status == 'Terminé'
                            ? '#f04438'
                            : certificat.status == 'En cours'
                              ? '#28b45b'
                              : certificat.status == 'En attente'
                                ? '#ffbf00'
                                : '#1d71b8'
                        "
                        class="mb-6 px-3 py-2 text-sm font-medium text-center text-white rounded-full font-semibold focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-500 dark:hover:bg-green-600 dark:focus:ring-green-600">
                        {{ certificat.status }}
                      </p>
                    </figcaption>
                  </a>
                </figure>

                <div class="p-5">
                  <p class="mb-2 text-xl text-gray-900 font-semibold">
                    {{
                    certificat.fullname ||
                    certificat.name ||
                    "Nom non disponible"
                    }}
                  </p>

                  <p class="mb-1 font-normal text-gray-700">
                    {{ certificat.shortname || "Shortname non disponible" }}
                  </p>

                  <div class="flex items-center justify-between gap-2 mt-2">
                    <span class="font-normal text-gray-700">
                      {{ certificat.plateforme || "Moodle" | uppercase }}
                    </span>

                    <div class="flex items-center gap-2">
                      <button *ngIf="certificat.certificatType === 'webinaire'" (click)="copyLink(certificat)"
                        class="btn focus:outline-none hover:bg-blue-100 focus:ring-2 focus:ring-gray-100 text-gray-700 w-fit text-center transition-all"
                        title="Copier le lien">
                        <!-- Icône lien (état normal) -->
                        <svg *ngIf="copiedCertificatId !== certificat.id" style="margin: 0 auto"
                          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                          stroke="currentColor" class="w-9 h-9 text-blue-600">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                        </svg>

                        <!-- Icône succès (affichée 2 secondes après copie) -->
                        <svg *ngIf="copiedCertificatId === certificat.id" style="margin: 0 auto"
                          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-9 h-9 text-green-500">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                      </button>
                      <button (click)="ViewCertificateDetails(certificat)"
                        class="btn focus:outline-none hover:bg-blue-100 focus:ring-2 focus:ring-gray-100 text-gray-700 w-fit text-center">
                        <svg style="margin: 0 auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                          stroke-width="1" stroke="currentColor" class="w-9 h-9" [style.color]="'blueColor'">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                      </button>

                      <button (click)="ViewCertificateDetailsToModifie(certificat)" *ngIf="!isBeninGestionnaire"
                        class="btn focus:outline-none hover:bg-green-100 focus:ring-2 focus:ring-green-100 p-1 text-gray-700 w-fit text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                          stroke="currentColor" class="w-10 h-6" [style.color]="'#79D99C'">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                        </svg>
                      </button>
                      <button *ngIf="!isBeninGestionnaire && certificat.certificatType === 'parcours'"
                        (click)="duplicateCertificate(certificat)"
                        class="btn focus:outline-none hover:bg-blue-100 focus:ring-2 focus:ring-blue-100 p-1 text-gray-700 w-fit text-center"
                        title="Dupliquer ce certificat">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-9 h-9 text-blue-600">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                        </svg>
                      </button>

                      <button *ngIf="!isBeninGestionnaire && certificat.certificatType === 'horsParcours'"
                        (click)="goToDuplicate(certificat.externalId)"
                        class="btn focus:outline-none hover:bg-blue-100 focus:ring-2 focus:ring-blue-100 p-1.5 text-gray-700 w-fit text-center rounded-lg transition-all duration-200"
                        title="Dupliquer ce certificat">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8"
                          stroke="currentColor" class="w-7 h-7 text-blue-600">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 17.25v3.375a1.125 1.125 0 0 1-1.125 1.125h-9a1.125 1.125 0 0 1-1.125-1.125v-9a1.125 1.125 0 0 1 1.125-1.125H9" />
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9.75 3.375h8.625c.621 0 1.125.504 1.125 1.125v8.625c0 .621-.504 1.125-1.125 1.125H9.75a1.125 1.125 0 0 1-1.125-1.125V4.5c0-.621.504-1.125 1.125-1.125Z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="self-stretch flex justify-center mt-4 w-full">
              <mat-paginator #paginator [length]="currentTotalElements" [pageSize]="currentPageSize"
                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPageIndex" (page)="onPageChange($event)"
                showFirstLastButtons="true">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 1 — Détail / Édition du certificat
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="showCertificatDetailsModal" style="background-color: #0a0a0a7d; z-index: 999999"
      class="overflow-y-auto overflow-x-hidden fixed inset-0 z-50 flex justify-center items-start">
      <div class="relative w-full max-w-5xl mx-4 my-10 bg-white rounded-lg shadow dark:bg-gray-700 px-8">
        <!-- En-tête -->
        <div class="flex items-center justify-between p-4 border-b">
          <h2 class="text-lg font-semibold text-gray-900">
            <ng-container *ngIf="!isBeninGestionnaire">
              {{
              editCertificatMode
              ? "Modifier le certificat"
              : "Détails du certificat"
              }}
            </ng-container>
            <ng-container *ngIf="isBeninGestionnaire">
              Détails du certificat
            </ng-container>
          </h2>
          <div class="flex items-center gap-2">
            <ng-container *ngIf="!isBeninGestionnaire">
              <!-- Bouton Inscrire apprenants (hors webinaire) -->
              <button style="background-color: rgb(94, 166, 253)"
                *ngIf="selectedCertificat.certificatType !== 'webinaire'" type="button" (click)="addUserModal()"
                class="transition bg-gray-100 inline-flex items-center gap-1 py-2 px-3 text-sm font-semibold text-gray-900 rounded-lg shadow hover:bg-gray-200">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                Inscrire des apprenants
              </button>
              <!-- Bouton Ajouter intervenant (webinaire) -->
              <button style="background-color: rgb(42, 128, 232)"
                *ngIf="selectedCertificat.certificatType === 'webinaire'" type="button"
                (click)="openAddModeratorModal()"
                class="transition bg-gray-100 inline-flex items-center gap-1 py-2 px-3 text-sm font-semibold text-gray-900 rounded-lg shadow hover:bg-gray-200">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                Ajouter un intervenant
              </button>
            </ng-container>
            <!-- Bouton fermer -->
            <button type="button" (click)="closeDetails()"
              class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 inline-flex justify-center items-center">
              <svg style="width: 0.75rem" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Corps -->
        <div class="pt-4 pb-6">
          <!-- ═══ MESSAGE DE SUCCÈS — bandeau discret au-dessus du formulaire ═══ -->
          <div *ngIf="updateSucces"
            class="mb-4 flex items-start gap-3 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-xl transition-all duration-200">
            <svg class="w-5 h-5 mt-0.5 flex-shrink-0 text-green-500" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12.75l2.25 2.25L15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-semibold text-sm">Succès !</p>
              <p class="text-sm">
                Les modifications ont été enregistrées avec succès.
              </p>
            </div>
          </div>
          <!-- ═══ Zone contenant le grid, avec overlay d'erreur possible ═══ -->
          <div class="relative">
            <!-- ═══ OVERLAY D'ERREUR — masque le formulaire d'édition ═══ -->
            <div *ngIf="updateWebinarError"
              class="absolute inset-0 z-20 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-lg">
              <div class="max-w-sm w-full mx-6 bg-red-50 border border-red-200 rounded-xl p-6 text-center shadow-lg">
                <svg class="w-10 h-10 mx-auto mb-3 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  stroke-width="1.5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p class="font-semibold text-red-800 mb-1">Erreur</p>
                <p class="text-sm text-red-700 mb-5">
                  {{ updateWebinarErrorText }}
                </p>
                <button type="button" (click)="updateWebinarError = false"
                  class="px-5 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg transition-colors">
                  Fermer
                </button>
              </div>
            </div>

            <div class="grid gap-4 grid-cols-2 transition-all duration-200" [class.blur-sm]="updateWebinarError"
              [class.opacity-40]="updateWebinarError" [class.pointer-events-none]="updateWebinarError">
              <!-- ID Externe -->
              <div class="col-span-2 sm:col-span-1">
                <label class="block mb-1 text-sm font-medium text-gray-700">ID Externe</label>
                <p *ngIf="!editCertificatMode"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                  {{ selectedCertificat.externalId || "Non renseigné" }}
                </p>
                <input *ngIf="editCertificatMode" type="text" [(ngModel)]="selectedCertificat.externalId"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
              </div>
              <!-- ── Champ : Nom (commun) ── -->
              <div class="col-span-2 sm:col-span-1">
                <label class="block mb-1 text-sm font-medium text-gray-700">Nom</label>
                <p *ngIf="!editCertificatMode"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                  {{ selectedCertificat.name || "Nom non disponible" }}
                </p>
                <input *ngIf="editCertificatMode" type="text" [(ngModel)]="selectedCertificat.name"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
              </div>

              <!-- ── Champ : Statut (commun, lecture seule) ── -->
              <div class="col-span-2 sm:col-span-1">
                <label class="block mb-1 text-sm font-medium text-gray-700">Statut</label>
                <p class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                  <span [ngClass]="{
                      'text-green-700 font-semibold':
                        selectedCertificat.status === 'En cours',
                      'text-yellow-600 font-semibold':
                        selectedCertificat.status === 'En attente',
                      'text-red-600 font-semibold':
                        selectedCertificat.status === 'Terminé',
                    }">{{
                    selectedCertificat.status || "Statut non disponible"
                    }}</span>
                </p>
              </div>

              <!-- ══ BLOC CERTIFICATS (parcours + hors parcours) ══ -->
              <ng-container *ngIf="selectedCertificat?.certificatType !== 'webinaire'">
                <!-- Date de début -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Date de début</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    <ng-container *ngIf="selectedCertificat.certificatType === 'parcours'">
                      {{
                      selectedCertificat._startDateInput ||
                      (selectedCertificat.startdate | date: "dd/MM/yyyy") ||
                      "Date de début non disponible"
                      }}
                    </ng-container>
                    <ng-container *ngIf="
                        selectedCertificat.certificatType === 'horsParcours'
                      ">
                      {{
                      selectedCertificat._startDateInput ||
                      selectedCertificat.startDate ||
                      "Date de début non disponible"
                      }}
                    </ng-container>
                  </p>
                  <input *ngIf="editCertificatMode" type="date" [(ngModel)]="selectedCertificat._startDateInput"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Date de fin -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Date de fin</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    <ng-container *ngIf="selectedCertificat.certificatType === 'parcours'">
                      {{
                      selectedCertificat._endDateInput ||
                      (selectedCertificat.enddate | date: "dd/MM/yyyy") ||
                      "Date de fin non disponible"
                      }}
                    </ng-container>
                    <ng-container *ngIf="
                        selectedCertificat.certificatType === 'horsParcours'
                      ">
                      {{
                      selectedCertificat._endDateInput ||
                      selectedCertificat.endDate ||
                      "Date de fin non disponible"
                      }}
                    </ng-container>
                  </p>
                  <input *ngIf="editCertificatMode" type="date" [(ngModel)]="selectedCertificat._endDateInput"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Nom court -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Nom court</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{
                    selectedCertificat.shortname || "Nom court non disponible"
                    }}
                  </p>
                  <input *ngIf="editCertificatMode" type="text" [(ngModel)]="selectedCertificat.shortname"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Plateforme — affichage simple / dropdown en édition -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Plateforme</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.plateforme || "Non renseignée" }}
                  </p>
                  <select *ngIf="editCertificatMode" [(ngModel)]="selectedCertificat.plateforme"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg shadow border border-gray-300 text-sm text-gray-900">
                    <option value="" disabled>Choisissez la plateforme</option>
                    <option value="Moodle">Moodle</option>
                    <option value="Coursera">Coursera</option>
                    <option value="LinkedIn Learning">LinkedIn Learning</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>

                <!-- Catégorie -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Catégorie</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{
                    selectedCertificat.certifcatCategory?.categoryName ||
                    selectedCertificat.category?.categoryName ||
                    selectedCertificat.categoryName ||
                    "Non renseignée"
                    }}
                  </p>
                  <select *ngIf="editCertificatMode" [(ngModel)]="selectedCertificat._selectedCategoryId"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg shadow border border-gray-300 text-sm text-gray-900">
                    <option [ngValue]="null" disabled>
                      Choisissez la catégorie
                    </option>
                    <option *ngFor="let cat of categorys" [ngValue]="cat.id">
                      {{ cat.categoryName }}
                    </option>
                  </select>
                </div>

                <!-- Cohorte -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Cohorte</label>
                  <p *ngIf="!editCertificatMode || selectedCertificat.certificatType === 'horsParcours'"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.cohorte || selectedCertificat.offTrackCohort || "Non renseignée" }}
                  </p>
                  <select *ngIf="editCertificatMode && selectedCertificat.certificatType === 'parcours'"
                    [(ngModel)]="selectedCertificat.cohorte"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg shadow border border-gray-300 text-sm text-gray-900">
                    <option value="" disabled>Choisissez la cohorte</option>
                    <option *ngFor="let c of cohortesList" [value]="c.cohorteName">
                      {{ c.cohorteName }}
                    </option>
                  </select>
                </div>

                <!-- Code certificat (parcours + hors parcours) -->
                <div class="col-span-2 sm:col-span-1"
                  *ngIf="selectedCertificat.certificatType === 'horsParcours' || selectedCertificat.certificatType === 'parcours'">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Code certificat</label>

                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ getCertificatCodeLabel(selectedCertificat.certificatCode) || "Non renseigné" }}
                  </p>

                  <select *ngIf="editCertificatMode" [(ngModel)]="selectedCertificat._selectedCertificatCode"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg shadow border border-gray-300 text-sm text-gray-900">
                    <option [ngValue]="null">Aucun</option>
                    <option *ngFor="let c of certificatCodes" [ngValue]="c.code">
                      {{ c.label }}
                    </option>
                  </select>
                </div>

                <!-- URL du certificat -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">URL du certificat</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 truncate">
                    <a *ngIf="
                        selectedCertificat.urlCertificat ||
                        selectedCertificat.urlCertificate
                      " [href]="
                        selectedCertificat.urlCertificat ||
                        selectedCertificat.urlCertificate
                      " target="_blank" class="text-blue-600 underline">
                      {{
                      selectedCertificat.urlCertificat ||
                      selectedCertificat.urlCertificate
                      }}
                    </a>
                    <span *ngIf="
                        !selectedCertificat.urlCertificat &&
                        !selectedCertificat.urlCertificate
                      ">—</span>
                  </p>
                  <input *ngIf="editCertificatMode" type="text" [(ngModel)]="selectedCertificat.urlCertificat"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Description -->
                <div class="col-span-2">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Description</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 whitespace-pre-wrap">
                    {{ selectedCertificat.description || "Non renseignée" }}
                  </p>
                  <textarea *ngIf="editCertificatMode" rows="3" [(ngModel)]="selectedCertificat.description"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"></textarea>
                </div>
              </ng-container>
              <!-- ══ FIN BLOC CERTIFICATS ══ -->

              <!-- ══ BLOC WEBINAIRE ══ -->
              <ng-container *ngIf="selectedCertificat?.certificatType === 'webinaire'">
                <!-- Date du webinaire -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Date du webinaire</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.date | date: "dd/MM/yyyy" }}
                  </p>
                  <input *ngIf="editCertificatMode" type="date" [ngModel]="selectedCertificat.date | date: 'yyyy-MM-dd'"
                    (ngModelChange)="selectedCertificat.date = $event"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Heure de début -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Heure de début</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.startTime | slice: 0 : 5 }}
                  </p>
                  <input *ngIf="editCertificatMode" type="time" [(ngModel)]="selectedCertificat.startTime"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Heure de fin -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Heure de fin</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.endTime | slice: 0 : 5 }}
                  </p>
                  <input *ngIf="editCertificatMode" type="time" [(ngModel)]="selectedCertificat.endTime"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Type de webinaire -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Type de webinaire</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.webinaireType || "Non renseigné" }}
                  </p>
                  <select *ngIf="editCertificatMode" [(ngModel)]="selectedCertificat.webinaireType"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg shadow border border-gray-300 text-sm text-gray-900">
                    <option value="" disabled>Choisissez le type de webinaire</option>
                    <option *ngFor="let type of webinaireTypeOptions" [value]="type.value">
                      {{ type.label }}
                    </option>
                  </select>
                </div>

                <!-- Lien d'accès (Zoom) -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Lien d'accès</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 truncate">
                    <a *ngIf="selectedCertificat.urlZoom" [href]="selectedCertificat.urlZoom" target="_blank"
                      class="text-blue-600 underline">{{ selectedCertificat.urlZoom }}</a>
                    <span *ngIf="!selectedCertificat.urlZoom">Non renseigné</span>
                  </p>
                  <input *ngIf="editCertificatMode" type="text" [(ngModel)]="selectedCertificat.urlZoom"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                </div>

                <!-- Description -->
                <div class="col-span-2">
                  <label class="block mb-1 text-sm font-medium text-gray-700">Description</label>
                  <p *ngIf="!editCertificatMode"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5">
                    {{ selectedCertificat.description || "Non renseignée" }}
                  </p>
                  <textarea *ngIf="editCertificatMode" rows="3" [(ngModel)]="selectedCertificat.description"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"></textarea>
                </div>
              </ng-container>
              <!-- ══ FIN BLOC WEBINAIRE ══ -->

              <!-- Boutons d'action édition -->
              <div *ngIf="editCertificatMode" class="col-span-2 flex justify-end gap-3 mt-2 pt-4 border-t">
                <button type="button" (click)="editCertificatMode = false"
                  class="bg-gray-500 text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-gray-600 transition">
                  Annuler
                </button>
                <button type="button" (click)="showConfirmUpdateModal = true"
                  class="bg-green-600 text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-green-700 transition">
                  Enregistrer les modifications
                </button>
              </div>
            </div>
            <!-- fin grid -->
          </div>
          <!-- fin zone relative -->

          <!-- ── Confirmation mise à jour (inline overlay) ── -->
          <div *ngIf="showConfirmUpdateModal"
            class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40" style="z-index: 9999999">
            <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
              <h2 class="text-lg font-semibold mb-4 text-center text-gray-700">
                Confirmer la modification
              </h2>
              <p class="text-gray-600 mb-6 text-center">
                Êtes-vous sûr de vouloir enregistrer les modifications du
                certificat
                <strong>{{
                  selectedCertificat.displayname || selectedCertificat.name
                  }}</strong>
                ?
              </p>
              <div class="flex justify-center gap-4">
                <button (click)="saveCertificatModifications()"
                  class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition">
                  Confirmer
                </button>
                <button (click)="showConfirmUpdateModal = false"
                  class="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold transition">
                  Annuler
                </button>
              </div>
            </div>
          </div>

          <!-- ══ SECTION TESTS (parcours, mode consultation) ══ -->
          <ng-container *ngIf="
              !editCertificatMode &&
              selectedCertificat?.certificatType !== 'webinaire'
            ">
            <div *ngIf="selectedCertificat?.certificatType === 'parcours'" class="mt-8 pt-4 border-t">
              <h3 class="text-sm font-semibold text-gray-900 mb-4">
                Liste des tests
              </h3>

              <p *ngIf="testsByCertificate.length === 0" class="text-sm text-gray-500">
                Ce certificat n'a pas encore de test.
              </p>

              <div *ngIf="testsByCertificate.length > 0" class="overflow-x-auto rounded-lg">
                <table class="w-full text-sm text-left text-gray-500">
                  <thead class="text-sm text-white bg-green-700">
                    <tr>
                      <th class="px-6 py-3">Nom</th>
                      <th class="px-6 py-3">Date d'ouverture</th>
                      <th class="px-6 py-3">Date de fermeture</th>
                      <th class="px-6 py-3">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let test of testsByCertificate" class="bg-white border-b hover:bg-gray-50">
                      <td class="px-6 py-4 font-medium text-gray-900">
                        {{ test.name }}
                      </td>
                      <td class="px-6 py-4">
                        {{ test.openDate | date: "dd/MM/yyyy" }}
                      </td>
                      <td class="px-6 py-4">
                        {{ test.closeDate | date: "dd/MM/yyyy" }} à 23h59
                      </td>
                      <td class="px-6 py-4 flex items-center gap-1">
                        <!-- Voir -->
                        <button class="p-1 hover:bg-gray-100 rounded" (click)="onViewTestDetails(test.accessLink)"
                          title="Voir">
                          <svg class="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                          </svg>
                        </button>
                        <!-- Modifier -->
                        <button class="p-1 hover:bg-gray-100 rounded" (click)="
                            onViewTestFormForUpdate(
                              test,
                              'Modifier le test du certificat'
                            )
                          " title="Modifier">
                          <svg class="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                          </svg>
                        </button>
                        <!-- Supprimer -->
                        <button class="p-1 hover:bg-gray-100 rounded" (click)="onViewModalDelete(test)"
                          title="Supprimer">
                          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>

          <!-- ══ SECTION INTERVENANTS (webinaire, mode consultation) ══ -->
          <ng-container *ngIf="
              !editCertificatMode &&
              selectedCertificat?.certificatType === 'webinaire'
            ">
            <div class="mt-8 pt-4 border-t">
              <h3 class="text-sm font-semibold text-gray-900 mb-4">
                Liste des intervenants
              </h3>

              <p *ngIf="moderatorsByWebinar.length === 0" class="text-sm text-gray-500">
                Ce webinaire n'a pas encore d'intervenant.
              </p>

              <div *ngIf="moderatorsByWebinar.length > 0" class="overflow-x-auto rounded-lg">
                <table class="w-full text-sm text-left text-gray-500">
                  <thead class="text-sm text-white bg-green-700">
                    <tr>
                      <th class="px-6 py-3">Prénom</th>
                      <th class="px-6 py-3">Nom</th>
                      <th class="px-6 py-3">Email</th>
                      <th class="px-6 py-3">Rôle</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let mod of moderatorsByWebinar" class="bg-white border-b hover:bg-gray-50">
                      <td class="px-6 py-4 font-medium text-gray-900">
                        {{ mod.firstName }}
                      </td>
                      <td class="px-6 py-4">{{ mod.lastName }}</td>
                      <td class="px-6 py-4">{{ mod.email }}</td>
                      <td class="px-6 py-4">
                        <span class="px-2 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                          {{
                          mod.eModerator === "MODERATOR"
                          ? "Modérateur"
                          : "Animateur"
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>

          <!-- Pied du modal -->
          <div class="mt-6 pt-4 border-t flex justify-end gap-3" *ngIf="!editCertificatMode">
            <ng-container *ngIf="!isBeninGestionnaire">
              <button style="background-color: rgb(77, 147, 231)"
                *ngIf="selectedCertificat?.certificatType !== 'webinaire' && selectedCertificat?.certificatType !== 'horsParcours'"
                type="button"
                class="text-white inline-flex items-center font-semibold rounded-lg text-sm px-5 py-2.5 bg-blueDark transition"
                (click)="ViewTestForm('Ajouter un test au certificat')">
                Ajouter un test
              </button>
              <button style="background-color: rgb(0, 115, 255)"
                *ngIf="selectedCertificat?.certificatType === 'webinaire'" type="button"
                class="text-white inline-flex items-center font-semibold rounded-lg text-sm px-5 py-2.5 bg-blueDark transition"
                (click)="openAddModeratorModal()">
                Ajouter un intervenant
              </button>
            </ng-container>
            <button style="background-color: rgb(220, 38, 38)" type="button"
              class="text-white inline-flex items-center font-semibold rounded-lg text-sm px-5 py-2.5 bg-redDark transition"
              (click)="closeDetails()">
              Fermer
            </button>
          </div>
        </div>
        <!-- fin corps -->
      </div>
      <!-- fin modal content -->
    </div>
    <!-- ═══════════════════════════════════════════════════════════
     FIN MODAL 1
     ═══════════════════════════════════════════════════════════ -->

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 2 — Suppression d'un test
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="showDeleteModal" style="z-index: 9999999"
      class="bg-black bg-opacity-40 fixed inset-0 flex justify-center items-center">
      <div class="bg-white rounded-lg shadow dark:bg-gray-700 p-6 max-w-md w-full mx-4">
        <div class="flex flex-col items-center gap-4">
          <div class="w-12 h-12 flex items-center justify-center rounded-full bg-red-100">
            <svg class="h-7 w-7 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>
          <p class="text-center text-gray-600">
            Vous allez supprimer le test
            <strong>{{ selectedTest.name }}</strong>. Merci de confirmer.
          </p>
          <div class="flex gap-3">
            <button (click)="onDeleteTest()"
              class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition">
              Confirmer
            </button>
            <button (click)="closeSuppModal()"
              class="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold transition">
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 3 — Formulaire ajout / modification de test
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="showTestFormModal" style="z-index: 9999999"
      class="bg-black bg-opacity-40 overflow-y-auto fixed inset-0 flex justify-center items-center">
      <div class="relative w-full max-w-2xl mx-4 bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="flex items-center justify-between p-4 border-b">
          <h2 class="text-lg font-semibold text-gray-900">
            {{ testFormTitle }} : {{ selectedCertificat?.fullname }}
          </h2>
          <button type="button" (click)="closeTestModal()"
            class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 inline-flex justify-center items-center">
            <svg style="width: 0.75rem" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
          </button>
        </div>

        <div class="p-5">
          <!-- Alertes -->
          <div *ngIf="inValid" class="mb-3 bg-red-100 text-red-700 px-4 py-3 rounded">
            <strong>Erreur !</strong> Merci de remplir tous les champs.
          </div>
          <div *ngIf="serverError" class="mb-3 bg-red-100 text-red-700 px-4 py-3 rounded">
            <strong>Erreur !</strong> Erreur lors de l'envoi, merci de
            réessayer.
          </div>
          <div *ngIf="isSucces" class="mb-3 bg-green-100 text-green-700 px-4 py-3 rounded">
            <strong>Succès !</strong> Le test a été ajouté avec succès.
          </div>
          <div *ngIf="isUpdate" class="mb-3 bg-green-100 text-green-700 px-4 py-3 rounded">
            <strong>Succès !</strong> Le test a été modifié avec succès.
          </div>

          <form [formGroup]="testForm">
            <div class="grid gap-4 grid-cols-2">
              <div class="col-span-2">
                <label class="block mb-1 text-sm font-medium text-gray-900">Nom *</label>
                <input formControlName="name" type="text"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  [style.border]="
                    isFieldInvalid('name') ? '2px solid #EB4045' : ''
                  " />
              </div>
              <div class="col-span-2">
                <label class="block mb-1 text-sm font-medium text-gray-900">Cohorte *</label>
                <select formControlName="cohorte"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  [style.border]="
                    isFieldInvalid('cohorte') ? '2px solid #EB4045' : ''
                  ">
                  <option value="" disabled selected>
                    Sélectionnez une cohorte
                  </option>
                  <option *ngFor="let c of cohortesList" [value]="c.cohorteName">
                    {{ c.cohorteName }}
                  </option>
                </select>
              </div>
              <div class="col-span-2 sm:col-span-1">
                <label class="block mb-1 text-sm font-medium text-gray-900">Date d'ouverture *</label>
                <input formControlName="openDate" type="date"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  [style.border]="
                    isFieldInvalid('openDate') ? '2px solid #EB4045' : ''
                  " />
              </div>
              <div class="col-span-2 sm:col-span-1">
                <label class="block mb-1 text-sm font-medium text-gray-900">Date de fermeture *</label>
                <input formControlName="closeDate" type="date"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  [style.border]="
                    isFieldInvalid('closeDate') ? '2px solid #EB4045' : ''
                  " />
              </div>
              <div class="col-span-2">
                <label class="block mb-1 text-sm font-medium text-gray-900">Lien du test *</label>
                <input formControlName="accessLink" type="text"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  [style.border]="
                    isFieldInvalid('accessLink') ? '2px solid #EB4045' : ''
                  " />
              </div>
            </div>

            <div class="flex justify-end gap-3 mt-5">
              <button type="button" (click)="closeTestModal()"
                class="px-4 py-2 bg-redDark rounded-lg text-sm font-semibold text-white transition">
                Annuler
              </button>
              <button *ngIf="addButton" type="button" (click)="onSubmitTestForm()"
                class="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition">
                Envoyer
              </button>
              <button *ngIf="updateButton" type="button" (click)="onUpdateTestForm()"
                class="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition">
                Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 4 — Inscription des apprenants
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="addUser" style="z-index: 9999999"
      class="bg-black bg-opacity-40 overflow-y-auto fixed inset-0 flex justify-center items-center">
      <div class="relative w-full max-w-xl mx-4 bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="flex items-center justify-between p-4 border-b">
          <h2 class="text-lg font-semibold text-gray-900">
            Inscrire des apprenants — {{ selectedCertificat?.fullname }}
          </h2>
          <button type="button" (click)="closeAddUserModal()"
            class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 inline-flex justify-center items-center">
            <svg style="width: 0.75rem" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
          </button>
        </div>

        <div class="p-5">
          <!-- Alertes -->
          <div *ngIf="mutliNotif" class="mb-3 bg-green-100 text-green-700 px-4 py-3 rounded">
            <strong>Succès !</strong> Les apprenants ont été inscrits.
          </div>
          <div *ngIf="saveError || multiError" class="mb-3 bg-red-100 text-red-700 px-4 py-3 rounded">
            <strong>Erreur !</strong> Erreur lors de l'inscription des
            apprenants.
          </div>
          <div *ngIf="noFile" class="mb-3 bg-red-100 text-red-700 px-4 py-3 rounded">
            <strong>Erreur !</strong> Merci d'uploader un fichier.
          </div>

          <!-- Zone de dépôt fichier -->
          <label for="fichier"
            class="flex flex-col items-center justify-center border-4 border-dashed border-gray-300 rounded-lg h-36 cursor-pointer hover:border-gray-400 transition">
            <svg class="w-8 h-8 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
            <span *ngIf="fileSize === 0" class="mt-2 text-sm text-blue-500 font-semibold">Sélectionner un fichier</span>
            <span *ngIf="fileSize > 0 && fileIsValid" class="mt-2 text-sm text-green-600 font-semibold">{{ fileName
              }}</span>
            <span *ngIf="fileSize > 0 && !fileIsValid" class="mt-2 text-sm text-red-500 font-semibold">Fichier
              invalide</span>
            <input type="file" accept=".csv,.xlsx,.xls" (change)="onFileChange($event)" id="fichier" class="hidden" />
          </label>
          <p class="mt-2 text-xs text-gray-400">
            Formats acceptés : .xlsx, .csv
          </p>

          <div class="flex justify-end gap-3 mt-5">
            <button type="button" (click)="closeAddUserModal()"
              class="px-4 py-2 bg-redDark rounded-lg text-sm font-semibold text-white transition">
              Annuler
            </button>
            <button type="button" (click)="enrolment()"
              class="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 5 — Ajout d'un intervenant (Modérateur / Animateur) — webinaire
     Parcours : choix (nouveau / existant / import) → rôle → liste → informations / récapitulatif
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="addMentor" style="z-index: 9999999"
      class="bg-black/50 backdrop-blur-sm overflow-y-auto fixed inset-0 flex justify-center items-center p-4">
      <div class="relative w-full max-w-xl bg-white rounded-2xl shadow-2xl dark:bg-gray-700">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-100">
          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-3 min-w-0" style="display:flex;align-items:center;gap:12px;min-width:0;flex:1 1 auto">
              <button *ngIf="addSpeakerStep !== 'choice'" type="button" (click)="goBackAddSpeaker()"
                aria-label="Retour" style="width:36px;height:36px;min-width:36px;max-width:36px;flex:0 0 36px;padding:0;display:inline-flex;align-items:center;justify-content:center"
                class="flex-shrink-0 w-9 h-9 inline-flex justify-center items-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition-colors">
                <svg width="16" height="16" style="width:16px;height:16px;flex:0 0 auto;max-width:none" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <div class="min-w-0" style="min-width:0;flex:1 1 auto">
                <h2 class="text-lg font-semibold text-gray-900">
                  {{ addSpeakerTitle }}
                </h2>
                <p class="text-sm text-gray-500 mt-0.5">
                  {{ selectedCertificat?.name }}
                </p>
              </div>
            </div>
            <button type="button" (click)="closeAddModeratorModal()"
              class="text-gray-400 hover:bg-gray-100 hover:text-gray-700 rounded-full w-9 h-9 inline-flex justify-center items-center transition-colors">
              <svg style="width: 0.85rem" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
            </button>
          </div>

          <!-- Fil d'étapes -->
          <div class="flex flex-wrap items-center gap-1.5 mt-3 text-xs">
            <ng-container *ngFor="let step of addSpeakerSteps; let last = last">
              <span class="px-2 py-0.5 rounded-full" [ngClass]="
                  step.state === 'current'
                    ? 'bg-blue-100 text-blue-800 font-bold'
                    : step.state === 'done'
                    ? 'text-gray-700 font-semibold'
                    : 'text-gray-400'
                ">
                {{ step.label }}
              </span>
              <svg width="14" height="14" style="width:14px;height:14px;flex:0 0 auto;max-width:none" *ngIf="!last" class="w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" d="M9 6l6 6-6 6" />
              </svg>
            </ng-container>
          </div>
        </div>

        <div class="p-6 relative">
          <!-- ═══ OVERLAY D'ERREUR ═══ -->
          <div *ngIf="moderatorError"
            class="absolute inset-0 z-20 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-b-2xl">
            <div class="max-w-sm w-full mx-6 bg-red-50 border border-red-200 rounded-xl p-6 text-center shadow-lg">
              <svg width="40" height="40" style="width:40px;height:40px;flex:0 0 auto;max-width:none" class="w-10 h-10 mx-auto mb-3 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p class="font-semibold text-red-800 mb-1">Erreur</p>
              <p class="text-sm text-red-700 mb-5">
                {{ erreurModerateurText }}
              </p>
              <button type="button" (click)="moderatorError = false"
                class="px-5 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg transition-colors">
                Fermer
              </button>
            </div>
          </div>

          <!-- Alerte succès -->
          <div *ngIf="moderatorSuccess"
            class="mb-4 flex items-start gap-3 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-xl">
            <svg width="20" height="20" style="width:20px;height:20px;flex:0 0 auto;max-width:none" class="w-5 h-5 mt-0.5 flex-shrink-0 text-green-500" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12.75l2.25 2.25L15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-semibold text-sm">Succès !</p>
              <p class="text-sm">{{ moderatorSuccessText }}</p>
            </div>
          </div>

          <!-- ═══ ÉTAPE 1 : nouveau ou existant ═══ -->
          <div *ngIf="addSpeakerStep === 'choice'">
            <p class="text-sm text-gray-700 mb-4">Comment souhaitez-vous ajouter l'intervenant ?</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <button type="button" (click)="chooseNewSpeaker()"
                class="text-left border border-gray-300 rounded-xl p-5 flex flex-col gap-3 hover:border-blue-600 hover:bg-blue-50 transition-colors">
                <span class="w-11 h-11 rounded-lg bg-green-100 inline-flex items-center justify-center" style="width:44px;height:44px;min-width:44px;max-width:44px;flex:0 0 44px;align-self:flex-start;display:inline-flex;align-items:center;justify-content:center">
                  <svg width="24" height="24" style="width:24px;height:24px;flex:0 0 auto;max-width:none" class="w-6 h-6 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                </span>
                <span class="text-base font-semibold text-gray-900">Nouvel intervenant</span>
                <span class="text-sm text-gray-500">Créer une nouvelle fiche avec civilité, prénom, nom, email et rôle.</span>
              </button>
              <button type="button" (click)="chooseExistingSpeaker()"
                class="text-left border border-gray-300 rounded-xl p-5 flex flex-col gap-3 hover:border-blue-600 hover:bg-blue-50 transition-colors">
                <span class="w-11 h-11 rounded-lg bg-blue-100 inline-flex items-center justify-center" style="width:44px;height:44px;min-width:44px;max-width:44px;flex:0 0 44px;align-self:flex-start;display:inline-flex;align-items:center;justify-content:center">
                  <svg width="24" height="24" style="width:24px;height:24px;flex:0 0 auto;max-width:none" class="w-6 h-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9c0-3.9 3.1-7 7-7s7 3.1 7 7M16 4.5a4 4 0 0 1 0 7M19 14.5c1.8 1 3 3.3 3 6.5" />
                  </svg>
                </span>
                <span class="text-base font-semibold text-gray-900">Intervenant existant</span>
                <span class="text-sm text-gray-500">Choisir parmi les animateurs et modérateurs déjà enregistrés.</span>
              </button>
            </div>

            <!-- Import par fichier -->
            <button type="button" (click)="chooseImportSpeakers()"
              class="w-full text-left border border-dashed border-gray-400 rounded-xl px-4 py-3 mt-4 hover:border-blue-600 hover:bg-blue-50 transition-colors"
              style="display:flex;align-items:center;gap:14px">
              <span class="rounded-lg bg-gray-100 text-gray-700"
                style="width:40px;height:40px;min-width:40px;max-width:40px;flex:0 0 40px;display:inline-flex;align-items:center;justify-content:center">
                <svg width="20" height="20" style="width:20px;height:20px;flex:0 0 auto;max-width:none" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 16V4m0 0-4 4m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                </svg>
              </span>
              <span style="flex:1 1 0%;min-width:0">
                <span class="block text-sm font-semibold text-gray-900">Importer depuis un fichier Excel</span>
                <span class="block text-xs text-gray-500">Ajouter plusieurs intervenants d'un coup à l'annuaire (.xlsx).</span>
              </span>
            </button>

            <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="closeAddModeratorModal()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Annuler
              </button>
            </div>
          </div>

          <!-- ═══ IMPORT : ajout d'intervenants à l'annuaire via fichier Excel ═══ -->
          <div *ngIf="addSpeakerStep === 'import'">
            <!-- Avant import -->
            <ng-container *ngIf="!importResult">
              <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 text-sm text-gray-700">
                <p class="font-semibold text-gray-900 mb-1">Format attendu (.xlsx)</p>
                <p class="mb-2">
                  Une ligne d'en-tête, puis une ligne par intervenant, dans cet ordre de colonnes :
                  <strong>Email</strong>, <strong>Civilité</strong>, <strong>Prénom</strong>, <strong>Nom</strong>,
                  <strong>Rôle</strong> (Animateur ou Modérateur).
                </p>
                <button type="button" (click)="downloadIntervenantsTemplate()"
                  class="text-sm font-semibold text-blue-700 hover:underline" style="padding:0;background:none;border:0">
                  Télécharger le modèle
                </button>
              </div>

              <label class="block border-2 border-dashed border-gray-300 rounded-xl p-6 text-center cursor-pointer hover:border-blue-600 hover:bg-blue-50 transition-colors">
                <input type="file" accept=".xlsx" (change)="onImportFileChange($event)" style="display:none" />
                <svg width="28" height="28" style="width:28px;height:28px;margin:0 auto 8px;display:block" fill="none"
                  viewBox="0 0 24 24" stroke="#6b7280" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 16V4m0 0-4 4m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                </svg>
                <span *ngIf="!importFile" class="block text-sm text-gray-700">
                  <strong class="text-blue-700">Choisir un fichier</strong> (.xlsx)
                </span>
                <span *ngIf="importFile" class="block text-sm text-gray-900 font-semibold">{{ importFile.name }}</span>
                <span *ngIf="importFile" class="block text-xs text-gray-500 mt-1">Cliquer pour changer de fichier</span>
              </label>

              <p *ngIf="importErrorText" class="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">
                {{ importErrorText }}
              </p>

              <div class="flex justify-between gap-3 mt-6 pt-4 border-t border-gray-100">
                <button type="button" (click)="goBackAddSpeaker()"
                  class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                  Retour
                </button>
                <button type="button" (click)="submitImportSpeakers()" [disabled]="!importFile || importLoading"
                  class="px-5 py-2.5 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                  {{ importLoading ? 'Import en cours…' : 'Importer' }}
                </button>
              </div>
            </ng-container>

            <!-- Résultat -->
            <ng-container *ngIf="importResult">
              <div class="grid grid-cols-3 gap-3 mb-4" style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px">
                <div class="rounded-xl bg-green-50 border border-green-200 p-3 text-center">
                  <p class="text-2xl font-bold text-green-800">{{ importResult.imported }}</p>
                  <p class="text-xs text-green-800">importé(s)</p>
                </div>
                <div class="rounded-xl bg-gray-50 border border-gray-200 p-3 text-center">
                  <p class="text-2xl font-bold text-gray-800">{{ importResult.ignored }}</p>
                  <p class="text-xs text-gray-700">déjà existant(s)</p>
                </div>
                <div class="rounded-xl bg-red-50 border border-red-200 p-3 text-center">
                  <p class="text-2xl font-bold text-red-800">{{ importResult.errors?.length || 0 }}</p>
                  <p class="text-xs text-red-800">erreur(s)</p>
                </div>
              </div>

              <div *ngIf="importResult.errors?.length" class="border border-red-200 rounded-lg p-3 bg-red-50"
                style="max-height:10rem;overflow-y:auto">
                <p *ngFor="let err of importResult.errors" class="text-xs text-red-800 mb-1">{{ err }}</p>
              </div>

              <div class="flex justify-between gap-3 mt-6 pt-4 border-t border-gray-100">
                <button type="button" (click)="resetImport()"
                  class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                  Importer un autre fichier
                </button>
                <button type="button" (click)="chooseExistingSpeaker()"
                  class="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm">
                  Choisir parmi les intervenants
                </button>
              </div>
            </ng-container>
          </div>

          <!-- ═══ ÉTAPE 2 : choix du rôle ═══ -->
          <div *ngIf="addSpeakerStep === 'role'">
            <p class="text-sm text-gray-700 mb-4">Sélectionnez le rôle de l'intervenant :</p>
            <div class="flex flex-col gap-3">
              <button *ngFor="let role of listRole" type="button" (click)="selectSpeakerRole(role)"
                class="w-full text-left border border-gray-300 rounded-xl px-4 py-4 flex items-center gap-4 hover:border-blue-600 hover:bg-blue-50 transition-colors">
                <span class="w-11 h-11 flex-shrink-0 rounded-lg inline-flex items-center justify-center" style="width:44px;height:44px;min-width:44px;max-width:44px;flex:0 0 44px;display:inline-flex;align-items:center;justify-content:center"
                  [ngClass]="role.value === 'MODERATOR' ? 'bg-purple-100 text-purple-700' : 'bg-orange-100 text-orange-700'">
                  <svg width="24" height="24" style="width:24px;height:24px;flex:0 0 auto;max-width:none" *ngIf="role.value === 'MODERATOR'" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 3l8 3v6c0 4.5-3.4 8.2-8 9-4.6-.8-8-4.5-8-9V6l8-3Zm-3 9 2 2 4-4" />
                  </svg>
                  <svg width="24" height="24" style="width:24px;height:24px;flex:0 0 auto;max-width:none" *ngIf="role.value !== 'MODERATOR'" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3ZM5 10a7 7 0 0 0 14 0M12 17v5" />
                  </svg>
                </span>
                <span class="flex-1" style="flex:1 1 0%;min-width:0">
                  <span class="block text-base font-semibold text-gray-900">{{ role.name }}</span>
                  <span class="block text-sm text-gray-500">
                    {{ role.value === 'MODERATOR' ? 'Gère le chat et les questions du public' : 'Anime et présente le webinaire' }}
                  </span>
                </span>
                <svg width="20" height="20" style="width:20px;height:20px;flex:0 0 auto;max-width:none" class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  stroke-width="2">
                  <path stroke-linecap="round" d="M9 6l6 6-6 6" />
                </svg>
              </button>
            </div>
            <div class="flex justify-between gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="goBackAddSpeaker()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Retour
              </button>
              <button type="button" (click)="closeAddModeratorModal()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Annuler
              </button>
            </div>
          </div>

          <!-- ═══ ÉTAPE 3 : liste des intervenants du rôle (cases à cocher) ═══ -->
          <div *ngIf="addSpeakerStep === 'list'">
            <label class="block mb-1.5 text-sm font-medium text-gray-700">
              Rechercher un {{ selectedSpeakerRole?.name | lowercase }}
            </label>
            <div class="mb-3 bg-gray-50 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-blue-500"
              style="display:flex;align-items:center;gap:8px;padding:0 12px;border-radius:8px">
              <svg width="16" height="16" style="width:16px;height:16px;flex:0 0 16px;max-width:none;color:#6b7280" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="7" />
                <path stroke-linecap="round" d="M20 20l-4-4" />
              </svg>
              <input type="search" [(ngModel)]="existingSpeakerSearch" placeholder="Nom ou email…"
                style="flex:1 1 auto;min-width:0;border:0;background:transparent;outline:none;box-shadow:none;padding:10px 0"
                class="text-gray-900 text-sm" />
            </div>

            <div class="flex items-center justify-between mb-2">
              <p class="text-xs text-gray-500">
                {{ filteredExistingSpeakers.length }} {{ selectedSpeakerRole?.name | lowercase }}(s) —
                sélectionnez un ou plusieurs
              </p>
              <span *ngIf="selectedExistingSpeakers.length > 0"
                class="text-xs font-bold text-blue-800 bg-blue-100 rounded-full px-2.5 py-0.5">
                {{ selectedExistingSpeakers.length }} sélectionné(s)
              </span>
            </div>

            <!-- Chargement / erreur / vide -->
            <p *ngIf="existingSpeakersLoading" class="text-sm text-gray-500 py-6 text-center">Chargement…</p>
            <div *ngIf="!existingSpeakersLoading && existingSpeakersError"
              class="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">
              <p>Impossible de charger la liste des intervenants.</p>
              <p *ngIf="existingSpeakersErrorText" class="text-xs mt-1 text-red-600">{{ existingSpeakersErrorText }}</p>
              <button type="button" (click)="loadExistingSpeakers(selectedSpeakerRole!.value)"
                class="mt-2 text-xs font-semibold text-red-800 hover:underline" style="padding:0;background:none;border:0">
                Réessayer
              </button>
            </div>
            <p *ngIf="!existingSpeakersLoading && !existingSpeakersError && filteredExistingSpeakers.length === 0"
              class="text-sm text-gray-500 py-6 text-center border border-dashed border-gray-300 rounded-lg">
              Aucun {{ selectedSpeakerRole?.name | lowercase }} trouvé.
            </p>

            <div *ngIf="!existingSpeakersLoading && !existingSpeakersError"
              class="flex flex-col gap-2 max-h-80 overflow-y-auto pr-1" style="max-height:20rem;overflow-y:auto">
              <label *ngFor="let speaker of filteredExistingSpeakers"
                class="flex items-center gap-3 px-3.5 py-2.5 rounded-xl border transition-colors" [ngClass]="
                  isSpeakerAlreadyInWebinar(speaker)
                    ? 'border-gray-200 bg-gray-50 opacity-60 cursor-not-allowed'
                    : isExistingSpeakerSelected(speaker)
                    ? 'border-blue-600 ring-1 ring-blue-600 bg-blue-50 cursor-pointer'
                    : 'border-gray-200 bg-white hover:bg-blue-50 cursor-pointer'
                ">
                <span style="width:40px;height:40px;min-width:40px;max-width:40px;flex:0 0 40px;display:inline-flex;align-items:center;justify-content:center" class="w-10 h-10 flex-shrink-0 rounded-full inline-flex items-center justify-center text-sm font-bold"
                  [ngClass]="selectedSpeakerRole?.value === 'MODERATOR' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'">
                  {{ (speaker.firstName || '').charAt(0) }}{{ (speaker.lastName || '').charAt(0) }}
                </span>
                <span class="flex-1 min-w-0" style="flex:1 1 0%;min-width:0">
                  <span class="block text-sm font-semibold text-gray-900">
                    <span *ngIf="speaker.civility" class="font-normal text-gray-500">{{ speaker.civility }} </span>{{ speaker.firstName }} {{ speaker.lastName }}
                  </span>
                  <span class="block text-xs text-gray-500 truncate">{{ speaker.email }}</span>
                </span>
                <span *ngIf="isSpeakerAlreadyInWebinar(speaker)"
                  class="text-xs font-semibold text-gray-600 bg-gray-200 rounded-full px-2 py-0.5 whitespace-nowrap">
                  Déjà ajouté
                </span>
                <input type="checkbox" style="width:20px;height:20px;min-width:20px;max-width:20px;flex:0 0 20px" [checked]="isExistingSpeakerSelected(speaker)"
                  [disabled]="isSpeakerAlreadyInWebinar(speaker)" (change)="toggleExistingSpeaker(speaker)"
                  class="w-5 h-5 flex-shrink-0 rounded border-gray-400 text-blue-600 focus:ring-blue-500" />
              </label>
            </div>

            <div class="flex justify-between gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="goBackAddSpeaker()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Retour
              </button>
              <button type="button" (click)="continueWithExistingSpeakers()"
                [disabled]="selectedExistingSpeakers.length === 0"
                class="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                Continuer<span *ngIf="selectedExistingSpeakers.length > 0"> ({{ selectedExistingSpeakers.length }})</span>
              </button>
            </div>
          </div>

          <!-- ═══ ÉTAPE 4a : récapitulatif (plusieurs intervenants existants) ═══ -->
          <div *ngIf="addSpeakerStep === 'recap'" [class.blur-sm]="moderatorError" [class.opacity-40]="moderatorError"
            [class.pointer-events-none]="moderatorError" class="transition-all duration-200">
            <p class="text-sm text-gray-700 mb-4">
              Les intervenants suivants seront ajoutés au webinaire en tant que
              <strong>{{ selectedSpeakerRole?.name | lowercase }}</strong> :
            </p>
            <div class="flex flex-col gap-2 max-h-80 overflow-y-auto pr-1" style="max-height:20rem;overflow-y:auto">
              <div *ngFor="let speaker of selectedExistingSpeakers"
                class="flex items-start gap-3 px-3.5 py-3 rounded-xl border border-gray-200 bg-white">
                <span style="width:40px;height:40px;min-width:40px;max-width:40px;flex:0 0 40px;display:inline-flex;align-items:center;justify-content:center" class="w-10 h-10 flex-shrink-0 rounded-full inline-flex items-center justify-center text-sm font-bold"
                  [ngClass]="selectedSpeakerRole?.value === 'MODERATOR' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'">
                  {{ (speaker.firstName || '').charAt(0) }}{{ (speaker.lastName || '').charAt(0) }}
                </span>
                <div class="flex-1 min-w-0" style="flex:1 1 0%;min-width:0">
                  <p class="text-sm font-semibold text-gray-900">
                    <span *ngIf="speaker.civility" class="font-normal text-gray-500">{{ speaker.civility }} </span>{{ speaker.firstName }} {{ speaker.lastName }}
                  </p>
                  <p class="text-xs text-gray-500 truncate">{{ speaker.email }}</p>
                  <p *ngIf="speaker.bioModerator" class="text-xs text-gray-600 mt-1">{{ speaker.bioModerator }}</p>
                </div>
                <button type="button" (click)="toggleExistingSpeaker(speaker)" aria-label="Retirer"
                  class="text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full w-8 h-8 inline-flex justify-center items-center transition-colors">
                  <svg style="width: 0.75rem" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="goBackAddSpeaker()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Retour
              </button>
              <button type="button" (click)="onSubmitExistingSpeakers()"
                [disabled]="selectedExistingSpeakers.length === 0 || isSubmittingSpeaker || moderatorSuccess"
                class="px-5 py-2.5 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                {{ isSubmittingSpeaker && !moderatorSuccess ? 'Enregistrement…' : 'Enregistrer' }}
              </button>
            </div>
          </div>

          <!-- ═══ ÉTAPE 4b : informations de l'intervenant (nouveau, ou un seul existant pré-rempli) ═══ -->
          <ng-container *ngIf="addSpeakerStep === 'form'">
            <div *ngIf="addSpeakerMode === 'existing'"
              class="mb-4 flex items-start gap-3 bg-blue-50 text-blue-800 px-4 py-3 rounded-xl text-sm">
              <svg width="20" height="20" style="width:20px;height:20px;flex:0 0 auto;max-width:none" class="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                stroke-width="2">
                <circle cx="12" cy="12" r="9" />
                <path stroke-linecap="round" d="M12 11v5M12 8h.01" />
              </svg>
              <span>Informations pré-remplies depuis la fiche existante. Vous pouvez les modifier avant
                d'enregistrer.</span>
            </div>

            <!-- Formulaire -->
            <form [formGroup]="mentorForm" [class.blur-sm]="moderatorError" [class.opacity-40]="moderatorError"
              [class.pointer-events-none]="moderatorError" class="transition-all duration-200">
              <div class="grid gap-4 grid-cols-2">
                <!-- Civilité -->
                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">
                    Civilité<span *ngIf="addSpeakerMode === 'new'"> *</span>
                  </label>
                  <select formControlName="civility"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg border text-sm text-gray-900 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none"
                    [class.border-red-400]="
                      mentorForm.get('civility')?.invalid &&
                      mentorForm.get('civility')?.touched
                    " [class.border-gray-300]="
                      !(
                        mentorForm.get('civility')?.invalid &&
                        mentorForm.get('civility')?.touched
                      )
                    ">
                    <option [ngValue]="null" disabled>Choisissez la civilité</option>
                    <option *ngFor="let c of civilityOptions" [ngValue]="c.value">
                      {{ c.label }}
                    </option>
                  </select>
                  <p *ngIf="mentorForm.get('civility')?.invalid && mentorForm.get('civility')?.touched"
                    class="mt-1 text-xs text-red-600">
                    La civilité est obligatoire.
                  </p>
                </div>
                <!-- cellule vide : garde Prénom / Nom côte à côte sur la ligne suivante -->
                <div class="hidden sm:block sm:col-span-1"></div>

                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">Prénom *</label>
                  <input formControlName="firstName" type="text" placeholder="Prénom"
                    class="bg-gray-50 border text-gray-900 text-sm rounded-lg block w-full p-2.5 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none"
                    [class.border-red-400]="
                      mentorForm.get('firstName')?.invalid &&
                      mentorForm.get('firstName')?.touched
                    " [class.border-gray-300]="
                      !(
                        mentorForm.get('firstName')?.invalid &&
                        mentorForm.get('firstName')?.touched
                      )
                    " />
                </div>

                <div class="col-span-2 sm:col-span-1">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">Nom *</label>
                  <input formControlName="lastName" type="text" placeholder="Nom"
                    class="bg-gray-50 border text-gray-900 text-sm rounded-lg block w-full p-2.5 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none"
                    [class.border-red-400]="
                      mentorForm.get('lastName')?.invalid &&
                      mentorForm.get('lastName')?.touched
                    " [class.border-gray-300]="
                      !(
                        mentorForm.get('lastName')?.invalid &&
                        mentorForm.get('lastName')?.touched
                      )
                    " />
                </div>

                <div class="col-span-2">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">Email *</label>
                  <input formControlName="email" type="email" placeholder="email@exemple.com"
                    class="bg-gray-50 border text-gray-900 text-sm rounded-lg block w-full p-2.5 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none"
                    [class.border-red-400]="
                      mentorForm.get('email')?.invalid &&
                      mentorForm.get('email')?.touched
                    " [class.border-gray-300]="
                      !(
                        mentorForm.get('email')?.invalid &&
                        mentorForm.get('email')?.touched
                      )
                    " />
                </div>

                <div class="col-span-2">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">Biographie</label>
                  <textarea formControlName="bioModerator" rows="3" placeholder="Courte biographie..."
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none resize-none"></textarea>
                </div>

                <div class="col-span-2">
                  <label class="block mb-1.5 text-sm font-medium text-gray-700">Rôle *</label>
                  <select formControlName="role"
                    class="w-full px-3.5 py-2.5 bg-gray-50 rounded-lg border text-sm text-gray-900 transition-colors focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none"
                    [class.border-red-400]="
                      mentorForm.get('role')?.invalid &&
                      mentorForm.get('role')?.touched
                    " [class.border-gray-300]="
                      !(
                        mentorForm.get('role')?.invalid &&
                        mentorForm.get('role')?.touched
                      )
                    ">
                    <option [ngValue]="null" disabled>Choisissez le rôle</option>
                    <option *ngFor="let item of listRole" [ngValue]="item.value">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                <button type="button" (click)="goBackAddSpeaker()"
                  class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                  Retour
                </button>
                <button type="button" (click)="onSubmitModerator()"
                  [disabled]="mentorForm.invalid || isSubmittingSpeaker || moderatorSuccess"
                  class="px-5 py-2.5 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                  {{ isSubmittingSpeaker && !moderatorSuccess ? 'Enregistrement…' : 'Enregistrer' }}
                </button>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
     MODAL 6 — Import d'intervenants dans l'annuaire (sans webinaire)
     ═══════════════════════════════════════════════════════════ -->
    <div *ngIf="showImportIntervenantsModal" style="z-index: 9999999"
      class="bg-black/50 backdrop-blur-sm overflow-y-auto fixed inset-0 flex justify-center items-center p-4">
      <div class="relative w-full max-w-xl bg-white rounded-2xl shadow-2xl">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-100 flex items-start justify-between gap-3">
          <div style="min-width:0;flex:1 1 auto">
            <h2 class="text-lg font-semibold text-gray-900">Importer des intervenants</h2>
            <p class="text-sm text-gray-500 mt-0.5">
              Ajoute des animateurs et modérateurs à l'annuaire, sans les rattacher à un webinaire.
            </p>
          </div>
          <button type="button" (click)="closeImportIntervenantsModal()" [disabled]="importLoading"
            class="text-gray-400 hover:bg-gray-100 hover:text-gray-700 rounded-full w-9 h-9 inline-flex justify-center items-center transition-colors disabled:opacity-50">
            <svg style="width: 0.85rem" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
          </button>
        </div>

        <div class="p-6">
          <!-- Avant import -->
          <ng-container *ngIf="!importResult">
            <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 text-sm text-gray-700">
              <p class="font-semibold text-gray-900 mb-1">Format attendu (.xlsx)</p>
              <p class="mb-2">
                Une ligne d'en-tête, puis une ligne par intervenant, dans cet ordre de colonnes :
                <strong>Email</strong>, <strong>Civilité</strong>, <strong>Prénom</strong>, <strong>Nom</strong>,
                <strong>Rôle</strong> (Animateur ou Modérateur).
              </p>
              <button type="button" (click)="downloadIntervenantsTemplate()"
                class="text-sm font-semibold text-blue-700 hover:underline" style="padding:0;background:none;border:0">
                Télécharger le modèle
              </button>
            </div>

            <label class="block border-2 border-dashed border-gray-300 rounded-xl p-6 text-center cursor-pointer hover:border-blue-600 hover:bg-blue-50 transition-colors">
              <input type="file" accept=".xlsx" (change)="onImportFileChange($event)" style="display:none" />
              <svg width="28" height="28" style="width:28px;height:28px;margin:0 auto 8px;display:block" fill="none"
                viewBox="0 0 24 24" stroke="#6b7280" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 16V4m0 0-4 4m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
              </svg>
              <span *ngIf="!importFile" class="block text-sm text-gray-700">
                <strong class="text-blue-700">Choisir un fichier</strong> (.xlsx, 5 Mo max)
              </span>
              <span *ngIf="importFile" class="block text-sm text-gray-900 font-semibold">{{ importFile.name }}</span>
              <span *ngIf="importFile" class="block text-xs text-gray-500 mt-1">Cliquer pour changer de fichier</span>
            </label>

            <p *ngIf="importErrorText" class="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">
              {{ importErrorText }}
            </p>

            <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="closeImportIntervenantsModal()" [disabled]="importLoading"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50">
                Annuler
              </button>
              <button type="button" (click)="submitImportSpeakers()" [disabled]="!importFile || importLoading"
                class="px-5 py-2.5 bg-green-600 hover:bg-green-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                {{ importLoading ? 'Import en cours…' : 'Importer' }}
              </button>
            </div>
          </ng-container>

          <!-- Résultat -->
          <ng-container *ngIf="importResult">
            <div class="grid grid-cols-3 gap-3 mb-4" style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px">
              <div class="rounded-xl bg-green-50 border border-green-200 p-3 text-center">
                <p class="text-2xl font-bold text-green-800">{{ importResult.imported }}</p>
                <p class="text-xs text-green-800">importé(s)</p>
              </div>
              <div class="rounded-xl bg-gray-50 border border-gray-200 p-3 text-center">
                <p class="text-2xl font-bold text-gray-800">{{ importResult.ignored }}</p>
                <p class="text-xs text-gray-700">déjà existant(s)</p>
              </div>
              <div class="rounded-xl bg-red-50 border border-red-200 p-3 text-center">
                <p class="text-2xl font-bold text-red-800">{{ importResult.errors?.length || 0 }}</p>
                <p class="text-xs text-red-800">erreur(s)</p>
              </div>
            </div>

            <div *ngIf="importResult.errors?.length" class="border border-red-200 rounded-lg p-3 bg-red-50"
              style="max-height:10rem;overflow-y:auto">
              <p *ngFor="let err of importResult.errors" class="text-xs text-red-800 mb-1">{{ err }}</p>
            </div>

            <p class="mt-4 text-xs text-gray-500">
              Ces intervenants sont maintenant disponibles dans « Intervenant existant » lors de l'ajout à un webinaire.
            </p>

            <div class="flex justify-between gap-3 mt-6 pt-4 border-t border-gray-100">
              <button type="button" (click)="resetImport()"
                class="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                Importer un autre fichier
              </button>
              <button type="button" (click)="closeImportIntervenantsModal()"
                class="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-semibold text-white transition-colors shadow-sm">
                Terminer
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Confirmation ajout intervenant(s) -->
    <div *ngIf="showConfirmModeratorModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40"
      style="z-index: 99999999">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 mx-4">
        <h2 class="text-lg font-semibold text-gray-800 mb-3 text-center">
          Confirmer l'ajout
        </h2>
        <p *ngIf="pendingModeratorDtos.length === 0" class="text-gray-600 text-center mb-6">
          Êtes-vous sûr de vouloir ajouter
          <strong>{{ mentorForm.get("civility")?.value }}
            {{ mentorForm.get("firstName")?.value }}
            {{ mentorForm.get("lastName")?.value }}</strong>
          comme {{ getRoleLabel(mentorForm.get("role")?.value) | lowercase }} ?
        </p>
        <p *ngIf="pendingModeratorDtos.length > 0" class="text-gray-600 text-center mb-6">
          Êtes-vous sûr de vouloir ajouter
          <strong>{{ pendingModeratorDtos.length }} intervenant(s)</strong>
          comme {{ selectedSpeakerRole?.name | lowercase }} ?
        </p>
        <div class="flex justify-center gap-4">
          <button (click)="confirmModeratorCreation()"
            class="px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition text-sm">
            Confirmer
          </button>
          <button (click)="cancelModeratorCreation()"
            class="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition text-sm">
            Annuler
          </button>
        </div>
      </div>
    </div>

    <!-- Snackbars update -->
    <div *ngIf="updateSucces"
      class="fixed bottom-6 right-6 z-[9999999] flex items-center gap-3 bg-green-600 text-white px-5 py-3 rounded-lg shadow-lg text-sm font-semibold">
      <svg class="w-5 h-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
      {{ updateMessage }}
    </div>

    <div *ngIf="updateError"
      class="fixed bottom-6 right-6 z-[9999999] flex items-center gap-3 bg-red-600 text-white px-5 py-3 rounded-lg shadow-lg text-sm font-semibold">
      <svg class="w-5 h-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
      {{ updateMessage }}
    </div>
  </div>
</div>